//固件升级
export default [
    {
        path: 'firmwareUpdate',
        name: 'firmwareUpdate',
        meta: {
            title: '固件升级',
            icon: 'firmwareUpdate'
        },
        hidden: false,
        component: () => import("@/views/equipment/firmwareUpdate/index.vue"),
        children: [{
            path: 'firmwareManagement',
            name: 'firmwareManagement',
            meta: {
                title: '固件管理',
                icon: 'firmwareManagement'
            },
            hidden: false,
            component: () => import("@/views/equipment/firmwareUpdate/firmwareManagement.vue"),
        },{
            path: 'grayScaleTest',
            name: 'grayScaleTest',
            meta: {
                title: '灰度测试',
                icon: 'grayScaleTest'
            },
            hidden: false,
            component: () => import("@/views/equipment/firmwareUpdate/grayScaleTest.vue"),
        },{
            path: 'bluetoothUpgradeTask',
            name: 'bluetoothUpgradeTask',
            meta: {
                title: '蓝牙升级任务',
                icon: 'bluetoothUpgradeTask'
            },
            hidden: false,
            component: () => import("@/views/equipment/firmwareUpdate/bluetoothUpgradeTask.vue"),
        },{
            path: 'networkUpgradeTask',
            name: 'networkUpgradeTask',
            meta: {
                title: '网络升级任务',
                icon: 'networkUpgradeTask'
            },
            hidden: false,
            component: () => import("@/views/equipment/firmwareUpdate/networkUpgradeTask.vue"),
        },{
            path: 'formalUpgradeTaskInfo',
            name: 'formalUpgradeTaskInfo',
            meta: {
                title: '升级任务详情',
                icon: 'formalUpgradeTaskInfo'
            },
            hidden: true,
            component: () => import("@/views/equipment/firmwareUpdate/formalUpgradeTaskInfo.vue"),
        },{
            path: 'grayScaleTestInfo',
            name: 'grayScaleTestInfo',
            meta: {
                title: '升级任务详情',
                icon: 'grayScaleTestInfo'
            },
            hidden: true,
            component: () => import("@/views/equipment/firmwareUpdate/grayScaleTestInfo.vue"),
        }]
    }

]